import { SocketPnlContext } from "@shared/features/dashboard/SocketPnl.context";
import { GetTradesRequest, TradeData } from "@shared/types";
import useSocketPnl from "@shared/services/socket/useSocketPnl";
import React, { FC, PropsWithChildren, useMemo } from "react";
import { sharedLib } from "@shared/services/shared.service";
import { SkipToken } from "@reduxjs/toolkit/query";

interface DashboardTradesProps {
  getTradesArgs: GetTradesRequest | undefined | SkipToken;
  openTradesData?: TradeData[];
}

const SocketPnlProvider: FC<PropsWithChildren<DashboardTradesProps>> = ({
  children,
  getTradesArgs,
  openTradesData: propsOpenTradesData,
}) => {
  const { data: openTradesData } =
    sharedLib.sharedApi.trades.useGetOpenTradesDataQuery(getTradesArgs);

  const { socketPnlValue, useGlobalPnl } = useSocketPnl(
    propsOpenTradesData ?? openTradesData?.data
  );

  const contextValue = useMemo(
    () => ({
      socketPnlValue,
      useGlobalPnl,
    }),
    [socketPnlValue, useGlobalPnl]
  );

  return (
    <SocketPnlContext.Provider value={contextValue}>
      {children}
    </SocketPnlContext.Provider>
  );
};

export default SocketPnlProvider;
